<div class="tasks">

  <sc-master-detail [selection]="[selectedTask]" [data]="tasks" [newStyle]="true"
    (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
    (deleteEntry)="onDeleteEntry($event);">
    <ng-container *ngIf="workingCopyDetails">
      <form #displayForm="ngForm" class="form">
        <div class="task-details">
          <div class="scrollable">
            <div class="form-box grid no-field-space" *ngIf="workingCopyDetails">

              <mat-form-field style="grid-column: 1; grid-row: 1;" appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc.admin.tasks.sortOrder"></sc-dictionary-label>
                </mat-label>
                <input [(ngModel)]="workingCopyDetails.sortOrder" name="sortOrder" matInput [required]="false"
                  [maxlength]="10" [minlength]="0" />
              </mat-form-field>

              <sc-dictionary-field style="grid-column: 1; grid-row: 2;" [model]="workingCopyDetails.name"
                [defaultLabel]="'name'" [labelDictionaryKey]="'tmc-yard.common.name'" [required]="true"
                [maxlength]="255" (dictionaryChanged)="onDictionaryChanged()">
              </sc-dictionary-field>

              <mat-form-field style="grid-column: 1; grid-row: 3;" appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc.admin.tasks.executionType"></sc-dictionary-label>
                </mat-label>
                <mat-select [(ngModel)]="workingCopyDetails.executionType" name="executionType">
                  <mat-option *ngFor="let o of taskExecutionTypes" value="{{o}}">
                    <sc-dictionary-label dictionaryKey="tmc.admin.tasks.executionType.{{o}}"></sc-dictionary-label>
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field style="grid-column: 1; grid-row: 4;" appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc-yard.common.type"></sc-dictionary-label>
                </mat-label>
                <mat-select [required]="true" [(ngModel)]="workingCopyDetails.type" name="type">
                  <mat-option *ngFor="let o of taskTypes" value="{{o}}">
                    <sc-dictionary-label dictionaryKey="tmc.admin.tasks.type.{{o}}"></sc-dictionary-label>
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <ng-container *ngIf="this.workingCopyDetails.type === taskType.MESSAGE">
                <sc-dictionary-field style="grid-column: 1; grid-row: 5;" [model]="workingCopyDetails.message"
                  [defaultLabel]="'message'" [labelDictionaryKey]="'tmc.admin.tasks.message'"
                  [required]="this.workingCopyDetails.type === taskType.MESSAGE" [maxlength]="255"
                  (dictionaryChanged)="onDictionaryChanged()">
                </sc-dictionary-field>
              </ng-container>

              <ng-container *ngIf="this.workingCopyDetails.type === taskType.DOCUMENT">
                <div class="document-selection" style="grid-column: 1; grid-row: 5;">
                  <mat-form-field class="mat-form-field-readonly station-name" appearance="fill">

                    <mat-label>
                      <sc-dictionary-label dictionaryKey="tmc.admin.tasks.document"></sc-dictionary-label>
                    </mat-label>
                    <input matInput
                      [value]="'' | translate: [workingCopyDetails.documentTemplate.nameDictionaryKey, translationService.language, translationService.revision ]"
                      required [readonly]="true" *ngIf="workingCopyDetails.documentTemplate != null">

                    <input matInput [value]="''" required [readonly]="true"
                      *ngIf="workingCopyDetails.documentTemplate == null">

                    <sc-action-icon matSuffix (click)="selectDocument()" iconClass="fa-magnifying-glass"></sc-action-icon>
                  </mat-form-field>


                </div>
              </ng-container>

              <ng-container *ngIf="this.workingCopyDetails.type === taskType.ATTRIBUTE_CHANGE">
                <mat-form-field style="grid-column: 1; grid-row: 5;" appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc.admin.tasks.order-reference-old"></sc-dictionary-label>
                  </mat-label>
                  <input [(ngModel)]="workingCopyDetails.orderReferenceOld" name="orderReferenceOld" matInput
                    [required]="true" [maxlength]="255" />
                </mat-form-field>
                <mat-form-field style="grid-column: 1; grid-row: 6;" appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc.admin.tasks.order-reference-new"></sc-dictionary-label>
                  </mat-label>
                  <input [(ngModel)]="workingCopyDetails.orderReferenceNew" name="orderReferenceNew" matInput
                    [required]="true" [maxlength]="255" />
                </mat-form-field>
              </ng-container>

              <mat-form-field appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc.admin.tasks.processing-hint"></sc-dictionary-label>
                </mat-label>
                <textarea matInput [rows]="3" name="processingHint" [required]="false" [minLength]="0"
                  [(ngModel)]="workingCopyDetails.processingHint"></textarea>
              </mat-form-field>
            </div>
          </div>
        </div>


      </form>
    </ng-container>

    <ng-template masterDetailToolbar>

      <sc-cancel-button type="button" class="config-changed-button" (click)="cancel()"
        [disabled]="!cancelEnabled"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-button primary type="button" class="config-changed-button" (click)="save()"
        [disabled]="!saveEnabled"></sc-save-button>
    </ng-template>

  </sc-master-detail>

</div>
